import {Routes} from '@angular/router';
import {PrivacyPage} from './pages/privacy-page/privacy-page';

export const PRIVACY_ROUTES: Routes = [
  {
    path: '',
    component: PrivacyPage,
  }
]
